<template>
    <div class="g all">
        <mdAll
            v-for="(item, index) in obj"
            :key="index"
            :caption="item.caption"
            :content="item.content"
        ></mdAll>
    </div>
</template>

<script>
    import mdAll from '@/components/mdAll'

    export default {
        components: {
            mdAll
        },
        props: {
            obj: {
                type: Array,
                require: true
            }
        }
    }
</script>

<style scoped lang="scss">

    .g.all {
        text-align: right;

        .md.all {
            display: inline-flex;
            padding-right: 0;
            margin-top: $interval-xs !important;

            + .md.all {
                margin-left: $interval-s;
            }
        }
    }
</style>
